export enum Routes {
  home = "/",
  signin = "/login",
  signup = "/register",
  forgot = "/forgot-password",
  reset = "/reset-password",
  profile = "/profile",
  orders = "/profile/orders",
  profileOrder = "/profile/orders/:id",
  ingredients = "/ingredients",
  ingredient = "/ingredients/:id",
  feed = "/feed",
  feedOrder = "/feed/:id",
  notfound = "/not-found-404",
}
